import { type TypographyProps } from '@mui/material';
import { type ReactNode } from 'react';

import { SmallText } from './Typography.js';

type ErrorTextProps = TypographyProps & {
  readonly children: ReactNode;
};

const ErrorText = ({ children, ...props }: ErrorTextProps) => (
  <SmallText color="error" sx={{ mt: 1 }} {...props}>
    {children}
  </SmallText>
);

export default ErrorText;
